export const resolveOfflineOrderCode = (item = {}) =>
  String(
    item?.metadata?.offlineOrderCode ||
    item?.payload?.ordercode ||
    item?.payload?.order_code ||
    `OFFLINE-${String(item?.id || "").slice(0, 8)}`
  );
